import styled from 'styled-components';
export const Container = styled.div`
  display:${({visibility}) => visibility ?' ':'none'};
  position: absolute;
  /* visibility: ${({visibility}) => visibility ?' ':'hidden'}; */
  width: 100%;
  height:100%;
  overflow:auto;
  padding: 0.5rem;

  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`